import jsonp from 'jsonp';

import Start from './start'
import Megogo from './megogo'
import Videoteka from './videoteka'


export default {
	serverName: '//iptvn.idc.md/api/jsonp/',
    getAccount: function (callback) {
        jsonp(this.serverName + 'account?settings=1', null, callback);
    },
    login: function (abonent, pass, callback) {
        jsonp(this.serverName + 'login?login=' + abonent + '&pass=' + pass + '&device=apple&&softid=web-idc-002&cli_serial=' + this.getCliSerial(), null, callback)
    },
    logout: function (callback) {
        jsonp(this.serverName + 'logout', null, callback);
    },
    getChannelList: function (show, protectionCode = '', callback) {
        jsonp(this.serverName + 'channel_list?icon=1&show=' + (show ? 1 : 0) + '&protect_code=' + protectionCode, null, callback);
    },
    getStreamUrl: function (cid, gmt, protect_code, callback) {
        jsonp(this.serverName + `get_url?cid=${cid}&gmt=${gmt}&protect_code=${protect_code}`, null, callback);
    },
    getTeletekaUrl: function (id, callback) {
        jsonp(this.serverName + `teleteka_geturl?id=${id}`, null, callback);
    },
    sendSettings: function (key, value, callback) {
        jsonp(this.serverName + 'settings_set?var=' + key + '&val=' + value, null, callback);
    },
    getEpg(channelId, date, callback) {
        // fetch('/temp.json')
        //     .then(res => res.json())
        //     .then(res => {
        //         callback(null, res);
        //     });
        jsonp(this.serverName + 'epg?cid=' + channelId + '&day=' + date, null, callback);
    },
    getCliSerial() {
        let localCliSerial;
        try {
            localCliSerial = localStorage.getItem('cliSerial');
        }
        catch(e) {
            localCliSerial = null;
        }
        if (localCliSerial) return localCliSerial;

        localCliSerial = btoa(Date.now()).slice(0, -2);

        try {
            localStorage.setItem('cliSerial', localCliSerial);
        }
        catch(e) {}

        return localCliSerial;
    },
    changeProtectionCode({oldCode, newCode, confirmCode}, callback) {
        jsonp(this.serverName + `settings_set?var=pcode&old_code=${oldCode}&new_code=${newCode}&confirm_code=${confirmCode}`, null, callback);
    },
    channelFiltering({cmd, protectCode, cid}, callback) {
        jsonp(this.serverName + `rule?cmd=${cmd}&protect_code=${protectCode}&cid=${cid}`, null, callback);
    },
    getMessageList(callback) {
        jsonp(this.serverName + 'messages?cmd=list', null, callback);
    },
    getMessage(id, callback) {
        jsonp(this.serverName + 'messages?cmd=get&id=' + id, null, callback);
    },

//     Можно запускать 1 раз для получения данных для авторизации
// apikey - это token
// kartina_id - kartina_id
    authStart(callback) {
        jsonp(this.serverName + 'entry/start_film', null, callback);
    },

    Start,
    Megogo,
    Videoteka
}



// WEBPACK FOOTER //
// ./src/libs/server.js